import PropTypes from 'prop-types';
import React from 'react';
import style from './Text.module.css';

export const Heading1 = ({ children, color, margin,  fontWeight, backgroundColor }) => {
  return (
    <span style={{ color, margin,  fontWeight, backgroundColor }} className={style.heading1}>
      {children}
    </span>
  );
};
Heading1.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string

};

export const Heading2 = ({ children, color, margin,  fontWeight, backgroundColor }) => {
  return (
    <span style={{ color, margin,  fontWeight, backgroundColor }} className={style.heading2}>
      {children}
    </span>
  );
};
Heading2.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string

};

export const Heading3 = ({ children, color, margin,  fontWeight, backgroundColor }) => {
  return (
    <span style={{ color, margin,  fontWeight, backgroundColor }} className={style.heading3}>
      {children}
    </span>
  );
};
Heading3.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string

};

export const Heading4 = ({ children, color, margin,  fontWeight, backgroundColor }) => {
  return (
    <span style={{ color, margin,  fontWeight, backgroundColor }} className={style.heading4}>
      {children}
    </span>
  );
};
Heading4.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string

};

export const Heading5 = ({ children, color, margin,  fontWeight, backgroundColor }) => {
  return (
    <span style={{ color, margin,  fontWeight, backgroundColor }} className={style.heading5}>
      {children}
    </span>
  );
};
Heading5.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string

};
export const Body1 = ({ children, color, margin, fontWeight, backgroundColor }) => {
  return (
    <span style={{ color, margin, fontWeight, backgroundColor }} className={style.body1}>
      {children}
    </span>
  );
};
Body1.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string

};

export const Body2 = ({ children, color, margin, fontWeight, backgroundColor, maxWidth, italic = false }) => {
  return (
    <span style={{ color, margin, fontWeight, backgroundColor, maxWidth, fontStyle: italic ? 'italic' : 'normal' }} className={style.body2}>
      {children}
    </span>
  );
};
Body2.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string,
  maxWidth: PropTypes.string,
};

export const Body3 = ({ children, color, margin, fontWeight, backgroundColor }) => {
  return (
    <span style={{ color, margin, fontWeight, backgroundColor }} className={style.body3}>
      {children}
    </span>
  );
};
Body3.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string,
};
export const WarningBody3 = ({ children, color, margin, fontWeight, backgroundColor }) => {
  return (
    <span style={{ color, margin, fontWeight, backgroundColor }} className={style.warningBody3}>
      {children}
    </span>
  );
};
WarningBody3.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string,
};

export const Body4 = ({ children, color, margin, fontWeight, backgroundColor }) => {
  return (
    <span style={{ color, margin, fontWeight, backgroundColor }} className={style.body4}>
      {children}
    </span>
  );
};
Body4.propTypes = {
  children: PropTypes.any,
  color: PropTypes.string,
  margin: PropTypes.string,
  fontWeight: PropTypes.number,
  backgroundColor: PropTypes.string
};


export const fontSizes = {
  heading1: '2.488rem',
  heading2: '2.074rem',
  heading3: '1.728rem',
  heading4: '1.44rem',
  heading5: '1.2rem',
  body1: '1rem',
  body2: '0.833rem',
  body3: '0.694rem',
  body4: '0.579rem',
};
